﻿$.fn.dxCtrlPageBc = function custom_dxCtrlPageBc(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlpagebc dx-ctrl");
        this.createInstance(new cdxCtrlPageBc(this, option));
    }
    return this;
}

window.gestCognoss = null
window.cdxCtrlPageBc = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    this.isMultiWindow = false

    if (typeof option.readOnly == 'undefined') option.readOnly = true
    if (typeof option.appli == 'undefined') option.appli = null

    var $DivBody = null
    var dxEntete = null
    function mConstruit() {

        if (gestCognoss == null) gestCognoss = new cognoss(option.bddCtrl)
        container.empty();
        container.css({
            "background-color": "white",
            "color": "black"
        })

        var dxScroll = $("<div/>").appendTo(container).dxScrollView({
            useNative: true,
            showScrollbar: 'always',
            onScroll: function (e) {
                dxEntete.mChangeScroll(dxScroll)
            },
            onInitialized: function (e) {
                e.element.find(".dx-scrollable-container").css("overflow-y", "scroll")
            }
        }).dxScrollView("instance")
        dxEntete = $("<div style='position:sticky;top:0;z-index:10;'/>").appendTo(dxScroll.content()).dxCtrlBcEntete({
            bddCtrl: option.bddCtrl,
            readOnly: option.readOnly,
            appli: option.appli,
            textSearch: ((getParameterUrl("q") == null) ? "" : decodeURIComponent(getParameterUrl("q"))),
            onChangeTextSearch: function (value) {
                //if (!gestCognoss.isAdmin()) {
                //    window.open(gestCognoss.mGetAppliCourante().urlcognoss + "/0/0/_/bc" + "?q=" + value, "_self")
                //} else {
                if (parametre.isLocalhost) history.pushState({ foo: 'bar' }, gestCognoss.mGetTitlePage(), ((parametre.isLocalhost) ? window.document.URLRacine : gestCognoss.mGetAppliCourante().urlcognoss) + "/0/0/_/bc" + "?q=" + encodeURIComponent(value));
                dxBcBody.option("elementBc", null)
                if (value == null || value.length == 0) { dxBcBody.option("txtSearch", "") }
                else { dxBcBody.option("txtSearch", value) }
                dxBcBody.mReload()
                //}
            },
            onChangeAppli: function (appli) {
                option.appli = appli
                dxBcBody.option("appli", appli)
                dxBcBody.option("elementBc", null)
                dxBcBody.mReload()
            },
            onDemandeExport: function () {
                dxBcBody.export()
            }
        }).dxCtrlBcEntete("instance")

        $DivBody = $("<div style='width:100%;text-align:center;'/>").appendTo(dxScroll.content())
        dxBcBody = $("<div style='display:inline-block;max-width:800px;width:100%;height:100%;text-align:left;padding-top:15px;'/>").appendTo($DivBody).dxCtrlBcBody({
            bddCtrl: option.bddCtrl,
            txtSearch: ((getParameterUrl("q") == null) ? "" : decodeURIComponent(getParameterUrl("q"))),
            appli: ((gestCognoss.isInApp()) ? null : dxEntete.option("appli")),
            elementBc: option.elementBc,
            readOnly: gestCognoss.isReadOnly(),
            onSelect: function (value) {
                if (value == null || (typeof value == "string" && value == "")) {
                    ////accueil
                    //if (!gestCognoss.isAdmin()) {
                    //    window.open(gestCognoss.mGetAppliCourante().urlcognoss + "/0/0/_/bc", "_self")
                    //} else {
                    history.pushState({ foo: 'bar' }, gestCognoss.mGetTitlePage(), ((parametre.isLocalhost) ? window.document.URLRacine : gestCognoss.mGetAppliCourante().urlcognoss) + "/0/0/_/bc");
                    mGoToAccueil()
                    //dxEntete.updateSearch("")
                    //dxBcBody.option("txtSearch", "")
                    //dxBcBody.option("elementBc", null)
                    //dxBcBody.mReload()
                    //}
                } else if (typeof value == "string") {
                    ////recherche
                    //if (!gestCognoss.isAdmin()) {
                    //    window.open(gestCognoss.mGetAppliCourante().urlcognoss + "?q=" & value, "_self")
                    //} else {
                    history.pushState({ foo: 'bar' }, gestCognoss.mGetTitlePage(), ((parametre.isLocalhost) ? window.document.URLRacine : gestCognoss.mGetAppliCourante().urlcognoss) + "?q=" + encodeURIComponent(value));
                    mGoToSearch(value)
                    //dxEntete.updateSearch(value)
                    //dxBcBody.option("txtSearch", value)
                    //dxBcBody.option("elementBc", null)
                    //dxBcBody.mReload()
                    //}
                } else {
                    ////dossier ou article
                    ////if (option.bddCtrl.getObjet(value).mGetTable().nom == "bc_dossier") {
                    //dxEntete.updateSearch("")
                    //dxBcBody.option("txtSearch", "")
                    ////}
                    //////if (!gestCognoss.isAdmin()) {
                    //////    var urlLink = ""
                    //////    if (value != null) {
                    //////        urlLink = option.bddCtrl.getObjet(value).objetMetier.mGetLink()
                    //////        //history.pushState({ foo: 'bar' }, parametre.nom, urlLink);
                    //////    } else {
                    //////        urlLink = gestCognoss.mGetAppliCourante().urlcognoss
                    //////        //history.pushState({ foo: 'bar' }, parametre.nom, gestCognoss.mGetAppliCourante().urlcognoss);
                    //////    }
                    //////    //$("<div style='position:absolute;top:0;background-color:rgba(0,0,0,0.2);z-index:100000;width:100%;height:100%;'/>").appendTo($("body"))
                    //////    window.open(urlLink, "_self")
                    //////} else {
                    var urlLink = ""
                    if (value != null) {
                        var obj = option.bddCtrl.getObjet(value)
                        urlLink = obj.objetMetier.mGetLink()
                        history.pushState({ foo: 'bar' }, gestCognoss.mGetTitlePage(), urlLink);
                        if (obj.mGetTable().nom == "bc_dossier") {
                            mGotToDossier(obj.cle())
                        } else {
                            mGotToArticle(obj.cle())
                        }
                        //history.pushState({ foo: 'bar' }, parametre.nom, urlLink);
                    } else {
                        urlLink = ((parametre.isLocalhost) ? window.document.URLRacine : gestCognoss.mGetAppliCourante().urlcognoss)
                        history.pushState({ foo: 'bar' }, gestCognoss.mGetTitlePage(), urlLink);
                        mGoToAccueil()
                        //history.pushState({ foo: 'bar' }, parametre.nom, gestCognoss.mGetAppliCourante().urlcognoss);
                    }
                    //dxBcBody.option("elementBc", value)
                    //dxBcBody.mReload()
                    //////}

                }
            }
        }).dxCtrlBcBody("instance")
    }

    window.addEventListener('popstate', (event) => {
        //history.pushState({ foo: 'bar' }, gestCognoss.mGetTitlePage(), gestCognoss.mGetAppliCourante().urlcognoss + "/0/0/_/bc" + "?q=" + value);
        //history.pushState({ foo: 'bar' }, gestCognoss.mGetTitlePage(), gestCognoss.mGetAppliCourante().urlcognoss + "/0/0/_/bc");
        //history.pushState({ foo: 'bar' }, gestCognoss.mGetTitlePage(), gestCognoss.mGetAppliCourante().urlcognoss + "?q=" & value);
        //appli.urlcognoss + "/" + appli.code_appli + "/0/" + objet.data.id_bc_article + "/" + replaceEncodableChars(objet.data.objet) + "/bc"
        //appli.urlcognoss + "/" + appli.code_appli + "/" + objet.data.id_bc_dossier + "/0/" + replaceEncodableChars(objet.data.objet) + "/bc"

        //ex urlrecherche
        //https://aide.mascaron.eu/0/0/_/bc?q=signature
        //location.pathname = /0/0/_/bc
        //location.search = ?q=signature
        //ex url dossier
        //https://aide.mascaron.eu/masc/12/0/Tableau_de_bord/bc
        //ex url article
        //https://aide.mascaron.eu/masc/0/42/Presentation_generale_du_tableau_de_bord/bc
        //ex url accueil
        if (location.pathname == "/") {
            mGoToAccueil()
        } else if (location.pathname == "/0/0/_/bc") {
            if (location.search.length > 0) {
                //recherche
                var txtSearch = location.search
                txtSearch = txtSearch.replace("?q=", "")
                txtSearch = decodeURIComponent(txtSearch)
                if (txtSearch.length > 0) {
                    //search
                    mGoToSearch(txtSearch)
                } else {
                    //Accueil
                    mGoToAccueil()
                }
            } else {
                //accueil
                mGoToAccueil()
            }
        } else {
            var idDossier = location.pathname.split("/")[2]
            var idArticle = location.pathname.split("/")[3]
            if (idDossier != "0") {
                //dossier
                mGotToDossier(idDossier)
            } else if (idArticle != "0") {
                //article
                mGotToArticle(idArticle)
            } else {
                //accueil
                mGoToAccueil()
            }
        }
    });

    function mGoToAccueil() {
        dxEntete.updateSearch("")
        dxBcBody.option("txtSearch", "")
        dxBcBody.option("elementBc", null)
        dxBcBody.mReload()
    }

    function mGoToSearch(txtSearch) {
        dxEntete.updateSearch(txtSearch)
        dxBcBody.option("txtSearch", txtSearch)
        dxBcBody.option("elementBc", null)
        dxBcBody.mReload()
    }
    function mGotToDossier(idDossier) {
        dxEntete.updateSearch("")
        dxBcBody.option("txtSearch", "")
        dxBcBody.option("elementBc", option.bddCtrl.getObjet("bc_dossier", idDossier).data)
        dxBcBody.mReload()
    }
    function mGotToArticle(idArticle) {
        dxEntete.updateSearch("")
        dxBcBody.option("txtSearch", "")
        dxBcBody.option("elementBc", option.bddCtrl.getObjet("bc_article", idArticle).data)
        dxBcBody.mReload()
    }

    this.mDisplayArticleBc = function (idBcArticle) {
        var obj = option.bddCtrl.getObjet("bc_article", idBcArticle)
        urlLink = obj.objetMetier.mGetLink()
        history.pushState({ foo: 'bar' }, gestCognoss.mGetTitlePage(), urlLink);
        if (obj.mGetTable().nom == "bc_dossier") {
            mGotToDossier(obj.cle())
        } else {
            mGotToArticle(obj.cle())
        }
        //var value = option.bddCtrl.getObjet("bc_article", idBcArticle).data
        //if (!gestCognoss.isAdmin()) {
        //    var urlLink = ""
        //    if (value != null) {
        //        urlLink = option.bddCtrl.getObjet(value).objetMetier.mGetLink()
        //        //history.pushState({ foo: 'bar' }, parametre.nom, urlLink);
        //    } else {
        //        urlLink = ((parametre.isLocalhost) ? window.document.URLRacine : gestCognoss.mGetAppliCourante().urlcognoss)
        //        //history.pushState({ foo: 'bar' }, parametre.nom, gestCognoss.mGetAppliCourante().urlcognoss);
        //    }
        //    //$("<div style='position:absolute;top:0;background-color:rgba(0,0,0,0.2);z-index:100000;width:100%;height:100%;'/>").appendTo($("body"))
        //    window.open(urlLink, "_self")
        //} else {
        //    dxBcBody.option("elementBc", value)
        //    dxBcBody.mReload()
        //}
    }

    var popupCurrent = null
    this.mAddPopup = function (data, optionPopup, justTab) {
        var obj = option.bddCtrl.getObjet(data)
        var popupExist = Me.mGetLstPopupData().filter(function (ele) {
            var objExist = option.bddCtrl.getObjet(ele.instance.option("data"))
            return objExist.mGetTable().nom == obj.mGetTable().nom && objExist.cle() == obj.cle()
        })[0]

        if (typeof popupExist == 'undefined') {
            var popup = $("<div/>").dxCtrlPagePopup({
                bddCtrl: option.bddCtrl,
                justTab: false,
                showClose: true,
                hasTab: false,
                widthRight: obj.mGetWidthPopup(),
                data: data,
                onFirstShown: function (popupPage, popupTitleElementIcone, popupTitleElementBt, contentElement) {
                    contentElement.css("padding", "0 20px 20px 20px")
                    obj.mGetIcone().appendTo(popupTitleElementIcone)
                    var optionBt = {}
                    mAddBtHistoConsultRappel(option.bddCtrl, optionBt, obj.mGetTable().id_table, obj.cle(),
                        function (optionPopup) {
                            var itemsToolbar = []

                            if (optionBt.buttons.length > 0) {
                                itemsToolbar.push(getToolbarSeparator())
                                itemsToolbar[itemsToolbar.length - 1].cssClass = "initial"
                                optionBt.buttons.forEach(function (bt) {
                                    itemsToolbar.push({
                                        cssClass: "initial",
                                        location: 'after',
                                        locateInMenu: 'auto',
                                        template(itemData, itemIndex, itemElement) {
                                            $("<div/>").appendTo(itemElement).dxCtrlButton(bt)
                                        },
                                    })
                                })
                            }
                            itemsToolbar.push(getToolbarSeparator())
                            itemsToolbar[itemsToolbar.length - 1].cssClass = "initial"
                            var toolbar = $("<div/>").appendTo(popupTitleElementBt).dxToolbar({
                                width: "100%",
                                items: itemsToolbar,
                                onContentReady: function (e) {
                                    e.component.element().find(".dx-toolbar-after").addClass("dx-surface")
                                }
                            }).dxToolbar("instance")
                            optionPopup.toolbar = toolbar
                            optionPopup.popupPage = popupPage
                            obj.contentTemplatePopup(contentElement, optionPopup)
                            popupPage.popup.repaint()
                        })
                }
            }).dxCtrlPagePopup("instance")
            popup.mShow()
            page.currentPopup = popup

        } else {
            popupExist.instance.mShow()
        }
    }
    this.mRemovePopup = function (data, funcFin) {
        if (popupCurrent != null) {
            if (typeof data == 'undefined') {
                popupCurrent.hide()
                popupCurrent = null
            } else {
                var obj = option.bddCtrl.getObjet(data)
                var objExist = option.bddCtrl.getObjet(popupCurrent.data)
                if (objExist.mGetTable().nom == obj.mGetTable().nom && objExist.cle() == obj.cle()) {
                    popupCurrent.hide()
                    popupCurrent = null
                }
            }
        }
        if (typeof funcFin != 'undefined') funcFin()
    }

    this.mGetLstPopupData = function () {
        var lst = []
        this.mGetLstPopupDiv().forEach(function (ele) {
            if (typeof ele.instance.option("data") != 'undefined') lst.push(ele)
        })
        this.mGetLstPopupPopup().forEach(function (ele) {
            if (typeof ele.instance.option("data") != 'undefined') lst.push(ele)
        })
        return lst
    }
    this.mGetLstPopupDiv = function (onlyWithData) {
        if (typeof onlyWithData == 'undefined') onlyWithData = false
        var lst = []
        $("body").find(".dx-ctrlpagepopupdiv").each(function () {
            var $ele = $(this)
            var instance = $ele.getInstance().popup.popupPage
            if (!onlyWithData || (onlyWithData && typeof instance.option("data") != 'undefined')) {
                lst.push({
                    instance: instance,
                    zIndex: instance.mGetZIndex(),
                    isHided: instance.isHided(),
                    ele: $ele
                })
            }
        })
        lst = lst.sort(function (o1, o2) { return o1.zIndex - o2.zIndex })
        return lst
    }
    this.mGetLstPopupPopup = function () {
        var lst = []
        $("body").find(".dxpagepopuppopup").each(function () {
            $ele = $(this)
            var instance = $ele.getInstance().popup.popupPage
            lst.push({
                instance: instance,
                zIndex: instance.mGetZIndex(),
                isHided: instance.isHided(),
                ele: $ele
            })
        })
        lst = lst.sort(function (o1, o2) { return o1.zIndex - o2.zIndex })
        return lst
    }

    this.mGetPopupPage = function (data) {
        var obj = option.bddCtrl.getObjet(data)
        var popupExist = this.mGetLstPopupData().filter(function (ele) {
            var objExist = option.bddCtrl.getObjet(ele.instance.option("data"))
            return objExist.mGetTable().nom == obj.mGetTable().nom && objExist.cle() == obj.cle()
        })[0]
        return ((typeof popupExist != 'undefined') ? popupExist.instance : null)
    }

    //this.mUpdateRappel = function () {}

    this.element = function () { return container; }

    mConstruit();
}